import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';
import {FONTS} from '../../utils/Constants';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    // Local replacement for the color-bearing CommonStyles.white_bg
    screenBackground: {
      backgroundColor: colors.background,
    },
    webcontainer: {
      maxWidth: 481,
      ...CommonStyles.br_16,
    },
    headerView: {
      marginHorizontal: 24,
    },
    contentContainer: {
      paddingHorizontal: 24,
      paddingBottom: 20,
      flex: 1,
      marginTop: 24,
    },
    title: {
      fontFamily: FONTS.boldFont,
      fontSize: 24,
      marginTop: 14,
      lineHeight: 36,
    },
    subtitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 16,
      marginTop: 5,
      lineHeight: 24,
    },
    scrollView: {
      flex: 1,
      marginTop: 24,
    },
    button: {
      flex: 1,
    },
    buttonContainer: {
      marginHorizontal: 24,
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
    },
    overlayContainer: {
      ...CommonStyles.full_overlay,
      ...CommonStyles.full_screen_height,
      ...CommonStyles.flex_center,
      backgroundColor: colors.overlayLight,
    },
  });

export default makeStyles;
